import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "@mui/icons-material";
import { Folder } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export default function IconsAvaliable({
  iconName,
  onClick,
  fontSize = "small",
  style = {},
  to,
  tooltip,
}) {
  const IconComponent = Icons[iconName];

  const renderIcon = () => {
    if (IconComponent) {
      const iconButton = (
        <IconButton onClick={onClick} style={style}>
          <IconComponent fontSize={fontSize} />
        </IconButton>
      );

      if (to) {
        return (
          <Tooltip title={tooltip}>
            <IconButton component={Link} to={to} style={style}>
              <IconComponent fontSize={fontSize} />
            </IconButton>
          </Tooltip>
        );
      } else {
        return <Tooltip title={tooltip}>{iconButton}</Tooltip>;
      }
    } else {
      return <Folder fontSize={fontSize} sx={style} />;
    }
  };

  return renderIcon();
}
